import Vue from 'vue'

export function numToKr (pWon) {
  let won = (`${pWon}`).replace(/,/g, '')
  const arrWon = ['원', '만', '억', '조', '경', '해', '자', '양', '구', '간', '정']
  let changeWon = ''
  const pattern = /(-?[0-9]+)([0-9]{4})/
  while (pattern.test(won)) {
    won = won.replace(pattern, '$1,$2') // 원, 만원 변경 연결
  }
  let arrCnt = won.split(',').length - 1
  for (let ii = 0; ii < won.split(',').length; ii++) {
    if (arrWon[arrCnt] === undefined) {
      alert('값의 수가 너무 큽니다.')
      break
    }
    let tmpwon = 0
    for (let i = 0; i < won.split(',')[ii].length; i++) {
      let num1 = won.split(',')[ii].substring(i, i + 1)
      tmpwon = tmpwon + Number(num1)
    }
    if (tmpwon > 0) {
      changeWon += won.split(',')[ii] + arrWon[arrCnt]
    }
    arrCnt--
  }
  if (changeWon.indexOf('만') === (changeWon.length - 1)) {
    changeWon += '원'
  }
  if (changeWon.length === 0) {
    changeWon = '0원'
  }
  return changeWon
}

export function numToComma (targetData) {
  let won = (`${targetData}`).replace(/[^0-9]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  return won
}

function install () {
  Vue.filter('numberToKor', numToKr)
  Vue.filter('numberToComma', numToComma)
}
export default install



// WEBPACK FOOTER //
// ./src/assets/js/ui.control.js